import firebaseKit from "./firebase/firebaseKit";
import firebase from "firebase/app";
import "firebase/database";
import AuthKit from "./AuthKit";
import { refs, getRef } from "./firebase/firebaseRefKit";
import { remove, set } from "firebase/database";

const authKit = new AuthKit();

export default class ChatModeratorKit {
  /**
   *
   * @param {object} publicMessage instance of PublicChatMessage class
   * @param {boolean} muted muted state
   */
  static setMuteMessageAuthor(publicMessage, muted = false) {
    const { eventUserId } = publicMessage.author;
    const { eventSlug } = publicMessage.getUrlParams();

    const ref = getRef(refs["public-messages"].$eventSlug.muted.$eventUserId, {
      eventSlug,
      eventUserId,
    });

    if (ref) set(ref, muted);
  }

  /**
   *
   * @param {object} publicMessage instance of PublicChatMessage class
   * @param {boolean} highlighted highlighted state
   */
  static setMessageHighlight(publicMessage, highlighted = false) {
    publicMessage.setIsHighlighted(highlighted);
  }

  /**
   *
   * @param {object} publicMessage instance of PublicChatMessage class
   * @param {boolean} hidden hidden state
   */
  static setMessageHidden(publicMessage, hidden = false) {
    publicMessage.setIsHidden(hidden);
  }

  static async downloadPublicMessageCSV({ event, page }) {
    const uri = `/socials/chats/public-messages/${event}/csvdownloads/${page}/`;
    return await authKit.doGet(uri, {});
  }

  static async downloadCorporateSingleChatMessagesCSV({
    organizationSlug,
    pageSlug,
    eventSlug,
    eventUserId,
  }) {
    const uri = `/socials/chats/corporate-messages/${organizationSlug}/${eventSlug}/csvdownloads/${pageSlug}/${eventUserId}/`;
    return await authKit.doGet(uri, {});
  }

  static async downloadCorporateAllChatMessagesCSV({
    organizationSlug,
    eventSlug,
    pageSlug,
  }) {
    const uri = `/socials/chats/corporate-messages/${organizationSlug}/${eventSlug}/csvdownloads/${pageSlug}/`;
    return await authKit.doGet(uri, {});
  }

  static deleteAllPublicMessages(ChatMessageCollection) {
    const ref = ChatMessageCollection.getTypedRef();
    remove(ref);
  }
}
